<template>
  <div class="themed-bg min-h-screen p-4 pb-20">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="text-2xl font-bold">Task Management</h2>
        <p class="themed-text-secondary">Manage agricultural operations efficiently</p>
      </div>
      <ThemeToggle />
    </div>

    <!-- Functional Task Manager -->
    <FunctionalTaskManager />
  </div>
</template>

<script setup>
import ThemeToggle from '@/components/ThemeToggle.vue'
import FunctionalTaskManager from '@/components/FunctionalTaskManager.vue'
</script>